import type { FC } from "react";
import { NavLink } from "react-router";

import { ROUTES } from "~/constants/routing";

import * as Styled from "./GetUpdatesFinePrint.styles";

interface IGetUpdatesFinePrintProps {
  agreement: "subscribing" | "signing up";
  ink?: boolean;
  newTab?: boolean;
}

export const GetUpdatesFinePrint: FC<IGetUpdatesFinePrintProps> = ({
  agreement,
  ink,
  newTab,
}) => {
  const linkProps = newTab
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};

  return (
    <Styled.Legal $ink={ink}>
      By {agreement} you agree to our{" "}
      <NavLink to={ROUTES.termsOfUse.createURL()} {...linkProps}>
        Terms
      </NavLink>{" "}
      and{" "}
      <NavLink to={ROUTES.privacyPolicy.createURL()} {...linkProps}>
        Privacy Policy
      </NavLink>
      . Informational signals only —{" "}
      <NavLink to={ROUTES.disclaimer.createURL()} {...linkProps}>
        full disclaimer
      </NavLink>
      .
    </Styled.Legal>
  );
};
